import React, { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  CardActions,
  Modal,
  TextField,
  Avatar,
  IconButton,
} from "@mui/material";
import ReplyIcon from "@mui/icons-material/Reply";
import "react-quill-new/dist/quill.snow.css";
import ReactQuill from "react-quill-new";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import Swal from "sweetalert2";
import PersonIcon from "@mui/icons-material/Person"; // You can choose any other icon
import Haikunator from "haikunator";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";


const userDataString = localStorage.getItem("Login_User_Community_All_Data");
const userData = userDataString ? JSON.parse(userDataString) : null;

const PostDetilas = () => {
  const { id } = useParams(); // Get the post ID from the route
  const [post, setPost] = useState(null);
  const [PostCatiId, setPostCatiId] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const userDataString = localStorage.getItem("Login_User_Community_Details");
  const token = JSON.parse(userDataString);
  const [categoryName, setCategoryName] = useState("");
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [posts, setPosts] = useState([]);
  const [replies, setReplies] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [userDetails, setUserDetails] = useState("");
  const [replyUserDetails, setReplyUserDetails] = useState([]);
  const [repliesWithDetails, setRepliesWithDetails] = useState([]);
  const [fetchData, setfetchData] = useState(false);
  const [loading, setLoading] = useState(true);

  const getAllInforUser = localStorage.getItem("Login_User_Community_All_Data");
  const userinfo = JSON.parse(getAllInforUser);
  const roleId = userinfo.role;

  const [isEdit, setIsEdit] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [ids, setId] = useState(null);
  const [likesData, setLikesData] = useState({});
  const [parentReplyId, setParentReplyId] = useState(null);  // State to store reply ID

  const authorDisplayName = (entity, details) => {
    if (entity?.display_name) return entity.display_name;

    const role = String(details?.role || "");
    if ((role === "2" || role === "5") && details?.is_anonymous === "Yes") {
      return details?.petname?.trim() ? details.petname : "Anonymous";
    }

    return details?.name || "Unknown";
  };


  const fetchUserDetailsById = async (userId) => {
    if (!userId) return null;

    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/getUserDetailsById/${userId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching user details:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchDetails = async () => {
      // Fetch post user details
      if (post?.user_id) {
        const postUserDetails = await fetchUserDetailsById(post.user_id);
        setUserDetails(postUserDetails);
      }

      // Fetch reply user details
      if (replies && replies.length > 0) {
        const replyDetails = await Promise.all(
          replies.map(async (reply) => {
            const userDetails = await fetchUserDetailsById(reply.user_id);
            return userDetails || { name: "Unknown", email: "Unknown" }; // Fallback for undefined
          })
        );
        setReplyUserDetails(replyDetails);
      }
    };

    fetchDetails();
  }, [post, replies]);

  useEffect(() => {
    const fetchPostDetails = async () => {
      try {
        //console.log("token",token);
        if (!token) {
          console.error("Token is missing. Redirecting to login.");
          navigate("/login");
          return;
        }
        const response = await axios.get(
          `${API_BASE_URL}/api/postGetByPrimaryID/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data && response.data.length > 0) {
          setPost(response.data[0]);
          setPostCatiId(response.data[0].cat_id);
        } else {
          setMessage("No post found.");
        }
      } catch (error) {
        setMessage("Post not found.");
        console.error(error);
      }
    };
    fetchPostDetails();
  }, [id, token, navigate]);

  useEffect(() => {
    const fetchCategoryName = async () => {
      try {
        if (PostCatiId) {
          const categoryResponse = await axios.get(
            `${API_BASE_URL}/api/getCategoryById/${PostCatiId}`
          );
          setCategoryName(categoryResponse.data.name);
        }
      } catch (error) {
        console.error("Error fetching category name:", error);
      }
    };

    fetchCategoryName();
  }, [PostCatiId]);

  // const handleOpenModal = async (replyId) => {
  //   try {
  //     const categoryResponse = await axios.get(
  //       `${API_BASE_URL}/api/getCategoryById/${PostCatiId}`
  //     );
  //    //console.log("categoryResponse---",categoryResponse);
  //     setCategoryName(categoryResponse.data.name);
  //     setParentReplyId(replyId);  //Changed for parent id not saved
  //     //setParentReplyId(categoryResponse.data.id);
  //     setOpen(true);
  //   } catch (error) {
  //     console.error("Error fetching category name:", error);
  //   }
  // };
  const handleOpenModal = async (replyId) => {
  try {
    const categoryResponse = await axios.get(
      `${API_BASE_URL}/api/getCategoryById/${PostCatiId}`
    );
    setCategoryName(categoryResponse.data.name);
    setParentReplyId(replyId);
    setOpen(true);
  } catch (error) {
    console.error("Error fetching category name:", error);
  }
};

  

  useEffect(() => {
    const fetchReplies = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/getRepliesByPostId/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("responsedata---===",response.data);

        setReplies(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching replies:", error);
        setLoading(false);
      }
    };

    fetchReplies();
  }, [id, fetchData]);

  
  const handleEdit = (postId) => {
    const postToEdit = replies.find((replies) => replies.id === postId);
    if (postToEdit) {
      setId(postToEdit.id); // Set the ID of the post being edited
      setCategoryName(categoryName); // Set the category name
      setContent(postToEdit.content); // Set the content
      setIsEdit(true);
      setOpen(true); // Open the modal
    }
  };

  const handlePost = async (parentReplyId) => {
    const userId = userData.id;
    // console.log("parentReplyId----====",parentReplyId);
    // Construct the post data
    const removeHtmlTags = (str) => str.replace(/<\/?[^>]+(>|$)/g, "");
    const newPost = {
      id: ids,
      post_id: id,
      parent_reply_id: parentReplyId,
      content: removeHtmlTags(content),
      user_id: userId,
    };


    try {
      const userDataString = localStorage.getItem(
        "Login_User_Community_Details"
      );
      const token = JSON.parse(userDataString);

      if (!token) {
        console.error("Token is missing. Redirecting to login.");
        navigate("/login");
        return;
      }

      let response;
      if (isEdit) {
        if (userData.role_id === 1) {
          const { user_id, ...remainingPostData } = newPost; // Exclude user_id
          newPost = remainingPostData;
        }

        response = await axios.put(
          `${API_BASE_URL}/api/repliePostUpdate/${ids}`, // Assuming `selectedPost` holds the post being edited
          newPost,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setPosts((prevPosts) => [response.data, ...prevPosts]);

        // Show success alert for update
        Swal.fire({
          title: "Success!",
          text: "Post updated successfully.",
          icon: "success",
          button: "Okay",
        });
      } else {
        // If creating, make a POST request to save the new post

        response = await axios.post(
          `${API_BASE_URL}/api/saveRepliedPost`,
          newPost,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Add the new post to the local state
        setPosts((prevPosts) => [response.data, ...prevPosts]);
        // Show success alert for new post creation
        Swal.fire({
          title: "Success!",
          text: "Post created successfully.",
          icon: "success",
          button: "Okay",
        });
      }

      // Clear form fields and close the modal
      setfetchData(!fetchData);
      setTitle("");
      setContent("");
      setOpen(false);
    } catch (error) {
      console.error(
        "Error saving post:",
        error.response?.data || error.message
      );
      // Show error alert
      Swal.fire({
        title: "Error",
        text: "There was an error saving the post. Please try again.",
        icon: "error",
        button: "Try Again",
      });
    }
  };

  useEffect(() => {
    const fetchRepliesDetails = async () => {
      if (!replies || replies.length === 0) return;

      try {
        const repliesWithDetails = await Promise.all(
          replies.map(async (reply) => {
            const response = await axios.get(
              `${API_BASE_URL}/api/getUserDetailsById/${reply.user_id}`
            );
            return { ...reply, userDetails: response.data };
          })
        );
        setLoading(true); // Start loader
        setRepliesWithDetails(repliesWithDetails);
      } catch (error) {
        console.error("Error fetching replies details:", error);
      } finally {
        setLoading(false); // Stop loader
      }
    };

    fetchRepliesDetails();
  }, [replies]);

  const modules = {
    toolbar: [
      // Basic text formatting
      [{ header: [1, 2, 3, false] }], // Headings
      ["bold", "italic", "underline", "strike"], // Bold, Italic, Underline, Strikethrough
      [{ list: "ordered" }, { list: "bullet" }], // Numbered and Bulleted lists
      [{ indent: "-1" }, { indent: "+1" }], // Indentation
      ["blockquote", "code-block"], // Blockquote and Code block
      ["link", "image", "video"], // Embed links, images, and videos
      [{ color: [] }, { background: [] }], // Text and background colors
      [{ align: [] }], // Align text
      ["clean"], // Remove formatting
      //["emoji-picker"],
    ],
    // handlers: {
    //   "emoji-picker": handleOpenEmojiPicker
    // },
  };

  const handleDelete = (id) => {
    const userDataString = localStorage.getItem("Login_User_Community_Details");
    const token = JSON.parse(userDataString);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${API_BASE_URL}/api/repliePosts/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`, // Replace with your token
            },
          })
          .then((response) => {
            Swal.fire("Deleted!", response.data.message, "success");

            // Update the local state to remove the deleted user
            setPosts((prevPosts) => prevPosts.filter((post) => post.id !== id));
          })
          .catch((error) => {
            Swal.fire("Error!", "Something went wrong.", "error");
            console.error("Error deleting user:", error);
          });
      }
    });
  };
  const handleLikeToggle = async (postId, likeableType) => {
    try {
      const userId = userData.id;
      //console.log("userId=======--------",userId);
      // Send POST request to toggle the like
      const response = await axios.post(
        `${API_BASE_URL}/api/toggle-like`,
        {
          user_id: userId,
          likeable_id: postId,
          likeable_type: likeableType,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const { likeable_id, like_count } = response.data;
  
      // Update the likesData state dynamically with the new count
      setLikesData((prev) => ({
        ...prev,
        [likeable_id]: {
          ...prev[likeable_id],
          liked: !prev[likeable_id]?.liked, // Toggle the liked state
          count: like_count, // Update the count with the value from the API
        },
      }));
    } catch (error) {
      console.error("Error toggling like:", error);
    }
  };

  useEffect(() => {
    const fetchLikesData = async () => {
      const userId = userData.id;
      try {
        const response = await axios.get(`${API_BASE_URL}/api/get-likes/${userId}`);
        const likesArray = response.data || []; // Handle undefined data gracefully
  
        // Transform the likes array into a structured object
        const likesData = {};
        likesArray.forEach((like) => {
          likesData[like.likeable_id] = {
            liked: like.user_liked,
            count: like.like_count, // Use the dynamic count returned by the API
            type: like.likeable_type,
          };
        });
  
        // Update the state with the transformed data
        setLikesData(likesData);
      } catch (error) {
        console.error("Error fetching likes data:", error);
      }
    };
  
    fetchLikesData(); // Fetch likes data on component mount
  }, [userData.id]); // Refetch likes if user ID changes


  const renderReplies = (replies, parentId) => {
    // Filter replies that belong to the current parent
    const filteredReplies = replies.filter(
      (reply) => reply.parent_reply_id === parentId
    );
    
   
  
    if (filteredReplies.length === 0) return null;
  
    return filteredReplies.map((reply) => (
      <Card
        key={reply.id}
        sx={{
          marginBottom: "15px",
          width: "100%",
          boxShadow: 3,
          marginLeft: parentId ? "40px" : "0", // Add margin for child replies
        }}
      >
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            marginBottom={2}
          >
            <Box display="flex" alignItems="center">
              <Avatar sx={{ width: 30, height: 30, marginRight: 2 }}>
                <PersonIcon sx={{ fontSize: 20 }} />
              </Avatar>
              <Typography sx={{ color: "#888", fontStyle: "italic" }}>
                {authorDisplayName(reply, reply.userDetails)}
              </Typography>
            </Box>
            <Typography
              sx={{ color: "#888", fontSize: "14px", fontStyle: "italic" }}
            >
              {new Date(reply.created_at).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </Typography>
          </Box>
          <Typography>{reply.content}</Typography>
          <Button
            size="small"
            color="primary"
            style={{ float: "right" }}
            onClick={() => handleOpenModal(reply.id)}
          >
            <ReplyIcon sx={{ fontSize: "25px", color: "black" }} />
            {roleId === "1" && (
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                <DeleteIcon
                  sx={{ color: "#555", cursor: "pointer" }}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleDelete(reply.id);
                  }}
                />
                <EditIcon
                  sx={{ color: "#555", cursor: "pointer" }}
                  onClick={(event) => {
                    event.stopPropagation(); // Prevent click event from propagating
                    handleEdit(reply.id);
                  }}
                />
              </Typography>
            )}
            <ThumbUpIcon
              sx={{
                color: likesData[reply.id]?.liked ? "blue" : "gray",
                cursor: "pointer",
                marginRight: "8px",
              }}
              onClick={(event) => {
                event.stopPropagation();
                handleLikeToggle(reply.id, "reply");
              }}
            />
            <Typography variant="body2" sx={{ marginRight: "15px" }}>
              {likesData[reply.id]?.count || 0} Likes
            </Typography>
          </Button>
          
          {renderReplies(replies, reply.id)}
        </CardContent>
      </Card>
    ));
  };
  //console.log("likesData====", likesData);
    return (

    <Box sx={{ padding: "20px" }}>
      {message ? (
        <Typography variant="h6" color="error">
          {message}
        </Typography>
      ) : post ? (
        <>
          <AppBar position="static" sx={{ backgroundColor: "#2196f3" }}>
            <Toolbar>
              {post.cat_id && (
                <Box>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "bold",
                      color: "white", // Optional: Add color to match the AppBar's contrast
                    }}
                  >
                    {post.title}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontSize: "14px", // Smaller font for category name
                      color: "white", // Optional: Add color to match the AppBar's contrast
                    }}
                  >
                    {categoryName}
                  </Typography>
                </Box>
              )}
            </Toolbar>
          </AppBar>

          <Card
  sx={{
    marginBottom: "15px",
    width: "100%",
    boxShadow: 3,
    "&:hover": { boxShadow: 6 },
  }}
>
  <CardContent>
    {/* Avatar, Created by Text, and Date */}
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      marginBottom={2}
    >
      {/* Left: Avatar and User Name */}
      <Box display="flex" alignItems="center">
        <Avatar sx={{ width: 30, height: 30, marginRight: 2 }}>
          <PersonIcon sx={{ fontSize: 20 }} />
        </Avatar>
        <Typography sx={{ color: "#888", fontStyle: "italic" }}>
          {authorDisplayName(post, userDetails)}
        </Typography>
      </Box>

      {/* Right: Created Date */}
      <Typography
        sx={{ color: "#888", fontSize: "14px", fontStyle: "italic" }}
      >
        {new Date(post.created_at).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })}
      </Typography>
    </Box>

    {/* Post Title */}
    <Typography variant="h6" sx={{ marginBottom: 2 }}>
      {post.title}
    </Typography>

    {/* Post Details */}
    <Typography
      variant="body2"
      sx={{ color: "#555", lineHeight: 1.6 }}
      dangerouslySetInnerHTML={{
        __html: post.post_details.replace(/\n/g, "<br />"),
      }}
    />

    {/* Actions: Reply + Like */}
    <Box display="flex" justifyContent="flex-end" alignItems="center" mt={2}>
      {/* Reply Icon Button */}
      <IconButton
        onClick={() => handleOpenModal(post.id)}
        size="small"
        title="Reply"
      >
        <ReplyIcon sx={{ fontSize: 25, color: "black" }} />
      </IconButton>

      {/* Like Icon Button */}
      <IconButton
        onClick={(event) => {
          event.stopPropagation();
          handleLikeToggle(post.id, "Post");
        }}
        size="small"
        title="Like"
      >
        <ThumbUpIcon
          sx={{
            color: likesData[post.id]?.liked === true ? "blue" : "gray",
            marginRight: "4px",
          }}
        />
      </IconButton>

      {/* Like Count */}
      <Typography variant="body2" sx={{ marginLeft: 1 }}>
        {likesData[post.id]?.count || 0} Likes
      </Typography>
    </Box>
  </CardContent>
</Card>

        </>
      ) : (
        <Typography></Typography>
      )}

      {loading ? (
        <Typography>Loading...</Typography>
      ) : repliesWithDetails.length > 0 ? (
        repliesWithDetails.map((reply, index) => (
           
          <Card
            key={index}
            sx={{ marginBottom: "15px", width: "100%", boxShadow: 3 }}
          >
            <CardContent>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom={2}
              >
                <Box display="flex" alignItems="center">
                  <Avatar sx={{ width: 30, height: 30, marginRight: 2 }}>
                    <PersonIcon sx={{ fontSize: 20 }} />
                  </Avatar>
                  <Typography sx={{ color: "#888", fontStyle: "italic" }}>
                    {
                    
                      authorDisplayName(reply, reply.userDetails)
                    }
                  </Typography>
                </Box>
                <Typography
                  sx={{ color: "#888", fontSize: "14px", fontStyle: "italic" }}
                >
                  {new Date(reply.created_at).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                </Typography>
              </Box>
              <Typography>{reply.content}</Typography>
              <Button
                size="small"
                color="primary"
                style={{ float: "right" }}
                //onClick={handleOpenModal}
                onClick={() => handleOpenModal(reply.id)}
              >
                <ReplyIcon sx={{ fontSize: "25px", color: "black" }} />
                {roleId === "1" && (
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    <DeleteIcon
                      sx={{ color: "#555", cursor: "pointer" }}
                      onClick={(event) => {
                        event.stopPropagation();
                        handleDelete(reply.id);
                      }}
                    />
                    <EditIcon
                      sx={{ color: "#555", cursor: "pointer" }}
                      onClick={(event) => {
                        event.stopPropagation(); // Prevent click event from propagating
                        handleEdit(reply.id);
                      }}
                    />
                  </Typography>
                )}

              {/* <ThumbUpIcon
                sx={{
                  color: likesData[reply.id]?.liked ? "blue" : "gray", // Change color based on liked state
                  cursor: "pointer",
                  marginRight: "8px",
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  handleLikeToggle(reply.id, "reply"); // Pass the type (e.g., "reply") to the toggle function
                }}
              />
              <Typography variant="body2" sx={{ marginRight: "15px" }}>
                {likesData[reply.id]?.count || 0} Likes--
              </Typography> */}
              <ThumbUpIcon
                sx={{
                  color: likesData[reply.id]?.liked ? "blue" : "gray",
                  cursor: "pointer",
                  marginRight: "8px",
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  handleLikeToggle(reply.id, "reply");
                }}
              />
              <Typography variant="body2" sx={{ marginRight: "15px" }}>
                {likesData[reply.id]?.count || 0} Likes
              </Typography>
             
              </Button>
            </CardContent>
          </Card>
        ))
      ) : (
        <Typography>No replies found.</Typography>
      )} 

      {/* {loading ? (
        <Typography>Loading...</Typography>
      ) : repliesWithDetails.length > 0 ? (
        renderReplies(repliesWithDetails, null) // Start rendering from the root replies
      ) : (
        <Typography>No replies found.</Typography>
      )} */}

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 800,
            height: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
          }}
        >
          <Typography variant="h6" sx={{ marginBottom: "15px" }}>
            Reply On {categoryName}
          </Typography>

          <TextField
            label="Category Name"
            variant="outlined"
            fullWidth
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            sx={{ marginBottom: "15px" }}
            disabled
          />
          <ReactQuill
            value={content}
            onChange={setContent}
            placeholder="Start typing here..."
            style={{
              marginBottom: "20px",
              background: "#fff",
              borderRadius: "5px",
              height: "142px",
            }}
            modules={modules}
            theme="snow"
          />
          <Button
            variant="contained"
            fullWidth
            //onClick={handlePost}
            onClick={() => handlePost(parentReplyId)}
            style={{ marginTop: "30px" }}
          >
            {isEdit ? "Update Post" : "Post"}
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default PostDetilas;

